import { mdCoursesForNotificationDropdown } from "../../utilities/MDCoursesList";

const fields = {
    techbytesUploadForm: {
        videoTitle: {
            videoTitle: 'input',
            elementConfig: {
                type: 'text'
            },
            value: '',
            label: 'Video Title',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
            },
            valid: false,
            touched: false,
            errorMessage: ''
        },
        videoTags: {
            elementType: 'input',
            elementConfig: {
                type: 'text'
            },
            value: '',
            label: 'Tags',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
            },
            valid: false,
            touched: false,
            errorMessage: ''
        },
        videoDescription: {
            elementType: 'markdown',
            elementConfig: {
                type: 'text'
            },
            value: '',
            label: 'Video Description',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
            },
            valid: false,
            touched: false,
            totalChar: 1000,
            remainingChar: 1000,
            errorMessage: ''
        },
        videoCategory: {
            elementType: 'select',
            elementConfig: {
                type: 'text',
            },
            options: [],
            dropdownOpen: false,
            value: -1,
            label: 'Category',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
            },
            valid: false,
            touched: false,
            errorMessage: ''
        },
        videoTranscript: {
            elementType: 'textarea',
            elementConfig: {
                type: 'text'
            },
            value: '',
            label: 'Video Transcript',
            disabled: false,
            validation: {
            },
            valid: false,
            touched: false,
            errorMessage: ''
        },
    },
    learningVideoUploadFormDefault: {
        videoTitle: {
            elementType: 'textarea',
            elementConfig: {
                type: 'text'
            },
            value: '',
            label: 'Video Title',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
            },
            valid: false,
            touched: false,
            totalChar: 100,
            remainingChar: 100,
            errorMessage: ''
        },
        videoTags: {
            elementType: 'input',
            elementConfig: {
                type: 'text'
            },
            value: '',
            label: 'Tags',
            disabled: false,
            validation: {
                required: {
                    value: false,
                    errorMessage: 'This is a required field'
                },
            },
            valid: false,
            touched: false,
            errorMessage: ''
        },
        videoSeries: {
            elementType: 'select',
            elementConfig: {
                type: 'text',
            },
            options: [],
            dropdownOpen: false,
            value: -1,
            label: 'Add to Course',
            disabled: false,
            validation: {
                required: {
                    value: false,
                    errorMessage: 'This is a required field'
                },
                isDropdown: {
                    value: false,
                    errorMessage: 'Please select a course from dropdown'
                },
            },
            valid: false,
            touched: false,
            errorMessage: ''
        },
        videoCategory: {
            elementType: 'select',
            elementConfig: {
                type: 'text',
            },
            options: [],
            dropdownOpen: false,
            value: -1,
            label: 'Category',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
                isDropdown: {
                    value: true,
                    errorMessage: 'Please select a value from dropdown'
                },
            },
            valid: false,
            touched: false,
            errorMessage: ''
        },
        videoDescription: {
            elementType: 'markdown',
            elementConfig: {
                type: 'text'
            },
            value: '',
            label: 'Video Description',
            disabled: false,
            validation: {
                required: {
                    value: false,
                    errorMessage: 'This is a required field'
                },
            },
            valid: false,
            touched: false,
            totalChar: 5000,
            remainingChar: 5000,
            errorMessage: ''
        },
        videoTranscript: {
            elementType: 'textarea',
            elementConfig: {
                type: 'text'
            },
            value: '',
            label: 'Video Transcript',
            disabled: false,
            validation: {
                required: {
                    value: false,
                    errorMessage: 'This is a required field'
                },
            },
            valid: false,
            touched: false,
            errorMessage: ''
        },
    },
    bulkVideoSelectCourseForm: {
        videoSeries: {
            elementType: 'select',
            elementConfig: {
                type: 'text',
            },
            options: [],
            dropdownOpen: false,
            value: -1,
            label: 'Select Course',
            disabled: false,
            validation: {
                required: {
                    value: false,
                    errorMessage: 'This is a required field'
                },
                isDropdown: {
                    value: false,
                    errorMessage: 'Please select a course from dropdown'
                },
            },
            valid: false,
            touched: false,
            errorMessage: ''
        },
        videoCategory: {
            elementType: 'select',
            elementConfig: {
                type: 'text',
            },
            options: [],
            dropdownOpen: false,
            value: -1,
            label: 'Category',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
                isDropdown: {
                    value: true,
                    errorMessage: 'Please select a value from dropdown'
                },
            },
            valid: false,
            touched: false,
            errorMessage: ''
        }
    },
    learningVideoUploadForm: {
        videoTitle: {
            elementType: 'textarea',
            elementConfig: {
                type: 'text'
            },
            value: '',
            label: 'Video Title',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
            },
            valid: false,
            touched: false,
            totalChar: 100,
            remainingChar: 100,
            errorMessage: ''
        },
        videoTags: {
            elementType: 'input',
            elementConfig: {
                type: 'text'
            },
            value: '',
            label: 'Tags',
            disabled: false,
            validation: {
                required: {
                    value: false,
                    errorMessage: ''
                },
            },
            valid: false,
            touched: false,
            errorMessage: ''
        },
        videoSeries: {
            elementType: 'select',
            elementConfig: {
                type: 'text',
            },
            options: [],
            dropdownOpen: false,
            value: -1,
            label: 'Add to Course',
            disabled: false,
            validation: {
                required: {
                    value: false,
                    errorMessage: 'This is a required field'
                },
                isDropdown: {
                    value: false,
                    errorMessage: 'Please select a course from dropdown'
                },
            },
            valid: false,
            touched: false,
            errorMessage: ''
        },
        videoCategory: {
            elementType: 'select',
            elementConfig: {
                type: 'text',
            },
            options: [],
            dropdownOpen: false,
            value: -1,
            label: 'Category',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
                isDropdown: {
                    value: true,
                    errorMessage: 'Please select a value from dropdown'
                },
            },
            valid: false,
            touched: false,
            errorMessage: ''
        },
        videoDescription: {
            elementType: 'markdown',
            elementConfig: {
                type: 'text'
            },
            value: '',
            label: 'Video Description',
            disabled: false,
            validation: {
                required: {
                    value: false,
                    errorMessage: ''
                },
            },
            valid: false,
            touched: false,
            totalChar: 5000,
            remainingChar: 5000,
            errorMessage: ''
        },
        videoTranscript: {
            elementType: 'textarea',
            elementConfig: {
                type: 'text'
            },
            value: '',
            label: 'Video Transcript',
            disabled: false,
            validation: {
                required: {
                    value: false,
                    errorMessage: 'This is a required field'
                },
            },
            valid: false,
            touched: false,
            errorMessage: ''
        },
    },
    bulkVideoUploadForm: {
        videoTitle: {
            elementType: 'textarea',
            elementConfig: {
                type: 'text'
            },
            value: '',
            label: 'Video Title',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
            },
            valid: false,
            touched: false,
            totalChar: 100,
            remainingChar: 100,
            errorMessage: ''
        },
        videoTags: {
            elementType: 'input',
            elementConfig: {
                type: 'text'
            },
            value: '',
            label: 'Tags',
            disabled: false,
            validation: {
                required: {
                    value: false,
                    errorMessage: ''
                },
            },
            valid: false,
            touched: false,
            errorMessage: ''
        },
        videoDescription: {
            elementType: 'markdown',
            elementConfig: {
                type: 'text'
            },
            value: '',
            label: 'Video Description',
            disabled: false,
            validation: {
                required: {
                    value: false,
                    errorMessage: ''
                },
            },
            valid: false,
            touched: false,
            totalChar: 5000,
            remainingChar: 5000,
            errorMessage: ''
        }
    },
    bulkVideoUploadFormDefault: {
        videoTitle: {
            elementType: 'textarea',
            elementConfig: {
                type: 'text'
            },
            value: '',
            label: 'Video Title',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
            },
            valid: false,
            touched: false,
            totalChar: 100,
            remainingChar: 100,
            errorMessage: ''
        },
        videoTags: {
            elementType: 'input',
            elementConfig: {
                type: 'text'
            },
            value: '',
            label: 'Tags',
            disabled: false,
            validation: {
                required: {
                    value: false,
                    errorMessage: ''
                },
            },
            valid: false,
            touched: false,
            errorMessage: ''
        },
        videoDescription: {
            elementType: 'markdown',
            elementConfig: {
                type: 'text'
            },
            value: '',
            label: 'Video Description',
            disabled: false,
            validation: {
                required: {
                    value: false,
                    errorMessage: ''
                },
            },
            valid: false,
            touched: false,
            totalChar: 5000,
            remainingChar: 5000,
            errorMessage: ''
        }
    },
    createCourseFormDefault: {
        courseTags: {
            elementType: 'input',
            elementConfig: {
                type: 'text'
            },
            value: '',
            label: 'Tags',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
            },
            valid: false,
            touched: false,
            errorMessage: ''
        },
        courseCategory: {
            elementType: 'select',
            elementConfig: {
                type: 'text',
            },
            options: [],
            dropdownOpen: false,
            value: -1,
            label: 'Category',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
                isDropdown: {
                    value: true,
                    errorMessage: 'Please select a value from dropdown'
                },
            },
            valid: false,
            touched: false,
            errorMessage: ''
        },
        courseLevel: {
            elementType: 'select',
            elementConfig: {
                type: 'text',
            },
            options: [
                {
                    id: 1,
                    label: 'Beginner',
                    value: 'BGN'
                },
                {
                    id: 2,
                    label: 'Intermediate',
                    value: 'INT'
                },
                {
                    id: 3,
                    label: 'Advanced',
                    value: 'ADV'
                },
            ],
            dropdownOpen: false,
            value: -1,
            label: 'Course Level',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
                isDropdown: {
                    value: true,
                    errorMessage: 'Please select a value from dropdown'
                },
            },
            valid: false,
            touched: false,
            errorMessage: ''
        },
        courseDescription: {
            elementType: 'markdown',
            elementConfig: {
                type: 'text'
            },
            value: '',
            label: 'Course Description',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
            },
            valid: false,
            touched: false,
            totalChar: 1000,
            remainingChar: 1000,
            errorMessage: ''
        },
        coursePrerequisites: {
            elementType: 'textarea',
            elementConfig: {
                type: 'text'
            },
            value: '',
            label: 'Course Pre-requisites',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
            },
            valid: false,
            touched: false,
            totalChar: 500,
            remainingChar: 500,
            errorMessage: ''
        },
    },
    createCourseForm: {
        courseTags: {
            elementType: 'input',
            elementConfig: {
                type: 'text'
            },
            value: '',
            label: 'Tags',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
            },
            valid: false,
            touched: false,
            errorMessage: ''
        },
        courseCategory: {
            elementType: 'select',
            elementConfig: {
                type: 'text',
            },
            options: [],
            dropdownOpen: false,
            value: -1,
            label: 'Category',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
                isDropdown: {
                    value: true,
                    errorMessage: 'Please select a value from dropdown'
                },
            },
            valid: false,
            touched: false,
            errorMessage: ''
        },
        courseLevel: {
            elementType: 'select',
            elementConfig: {
                type: 'text',
            },
            options: [
                {
                    id: 1,
                    label: 'Beginner',
                    value: 'BGN'
                },
                {
                    id: 2,
                    label: 'Intermediate',
                    value: 'INT'
                },
                {
                    id: 3,
                    label: 'Advanced',
                    value: 'ADV'
                },
            ],
            dropdownOpen: false,
            value: -1,
            label: 'Course Level',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
                isDropdown: {
                    value: true,
                    errorMessage: 'Please select a value from dropdown'
                },
            },
            valid: false,
            touched: false,
            errorMessage: ''
        },
        courseDescription: {
            elementType: 'markdown',
            elementConfig: {
                type: 'text'
            },
            value: '',
            label: 'Course Description',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
            },
            valid: false,
            touched: false,
            totalChar: 1000,
            remainingChar: 1000,
            errorMessage: ''
        },
        coursePrerequisites: {
            elementType: 'textarea',
            elementConfig: {
                type: 'text'
            },
            value: '',
            label: 'Course Pre-requisites',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
            },
            valid: false,
            touched: false,
            totalChar: 500,
            remainingChar: 500,
            errorMessage: ''
        },
    },
    createCoursePageForm: {
        courseTitle: {
            elementType: 'textarea',
            elementConfig: {
                type: 'text'
            },
            value: '',
            label: 'Course Title',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
            },
            valid: false,
            touched: false,
            totalChar: 100,
            remainingChar: 100,
            errorMessage: ''
        },
        courseTags: {
            elementType: 'input',
            elementConfig: {
                type: 'text'
            },
            value: '',
            label: 'Tags',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
            },
            valid: false,
            touched: false,
            errorMessage: ''
        },
        courseCategory: {
            elementType: 'select',
            elementConfig: {
                type: 'text',
            },
            options: [],
            dropdownOpen: false,
            value: -1,
            label: 'Category',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
                isDropdown: {
                    value: true,
                    errorMessage: 'Please select a value from dropdown'
                },
            },
            valid: false,
            touched: false,
            errorMessage: ''
        },
        courseLevel: {
            elementType: 'select',
            elementConfig: {
                type: 'text',
            },
            options: [
                {
                    id: 1,
                    label: 'Beginner',
                    value: 'BGN'
                },
                {
                    id: 2,
                    label: 'Intermediate',
                    value: 'INT'
                },
                {
                    id: 3,
                    label: 'Advanced',
                    value: 'ADV'
                },
            ],
            dropdownOpen: false,
            value: -1,
            label: 'Course Level',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
                isDropdown: {
                    value: true,
                    errorMessage: 'Please select a value from dropdown'
                },
            },
            valid: false,
            touched: false,
            errorMessage: ''
        },
        courseDescription: {
            elementType: 'markdown',
            elementConfig: {
                type: 'text'
            },
            value: '',
            label: 'Course Description',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
            },
            valid: false,
            touched: false,
            totalChar: 1000,
            remainingChar: 1000,
            errorMessage: ''
        },
        coursePrerequisites: {
            elementType: 'textarea',
            elementConfig: {
                type: 'text'
            },
            value: '',
            label: 'Course Pre-requisites',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
            },
            valid: false,
            touched: false,
            totalChar: 500,
            remainingChar: 500,
            errorMessage: ''
        },
    },
    LEgetStartedContactForm: {
        firstname: {
            elementType: 'input',
            elementConfig: {
                type: 'text'
            },
            value: '',
            label: 'First Name',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
                isName: {
                    value: true,
                    errorMessage: 'Please enter a valid name'
                }
            },
            valid: false,
            touched: false,
            errorMessage: ''
        },
        lastname: {
            elementType: 'input',
            elementConfig: {
                type: 'text'
            },
            value: '',
            label: 'Last Name',
            disabled: false,
            validation: {
                required: {
                    value: false,
                    errorMessage: ''
                },
                isName: {
                    value: true,
                    errorMessage: 'Please enter a valid name'
                }
            },
            valid: false,
            touched: false
        },
        email: {
            elementType: 'input',
            elementConfig: {
                type: 'email',
            },
            value: '',
            label: 'Email ID',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
                isEmail: {
                    value: true,
                    errorMessage: 'Please enter a valid email',
                },
            },
            valid: false,
            touched: false,
            errorMessage: ''
        },
        phone: {
            elementType: 'input',
            elementConfig: {
                type: 'text',
            },
            value: '',
            label: 'Phone Number (For eg, +919739xxxxx9 for India)',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
                isPhone: {
                    value: true,
                    errorMessage: 'Please enter a valid phone number'
                }
            },
            valid: false,
            touched: false,
            errorMessage: ''
        },
    },
    LEgetStartedProfileForm: {
        website: {
            elementType: 'input',
            elementConfig: {
                type: 'text'
            },
            value: '',
            label: 'Website URL',
            disabled: false,
            validation: {
                required: {
                    value: false,
                    errorMessage: 'This is a required field'
                },
                isUrl: {
                    value: true,
                    errorMessage: 'Please enter a valid URL. (For eg, https://www.edyoda.com)'
                },
            },
            valid: true,
            touched: false
        },
        linkedIn: {
            elementType: 'input',
            elementConfig: {
                type: 'text'
            },
            value: '',
            label: 'Link to your LinkedIn Profile',
            disabled: false,
            validation: {
                required: {
                    value: false,
                    errorMessage: 'This is a required field'
                },
                isUrl: {
                    value: true,
                    errorMessage: 'Please enter a valid URL. (For eg, www.linkedin.com/in/username)'
                },
            },
            valid: true,
            touched: false
        },
        github: {
            elementType: 'input',
            elementConfig: {
                type: 'text'
            },
            value: '',
            label: 'Link to your Github Profile',
            disabled: false,
            validation: {
                required: {
                    value: false,
                    errorMessage: 'This is a required field'
                },
                isUrl: {
                    value: true,
                    errorMessage: 'Please enter a valid URL. (For eg, www.github.com/username)'
                },
            },
            valid: true,
            touched: false
        },
        twitter: {
            elementType: 'input',
            elementConfig: {
                type: 'text'
            },
            value: '',
            label: 'Link to your Twitter Profile',
            disabled: false,
            validation: {
                required: {
                    value: false,
                    errorMessage: 'This is a required field'
                },
                isUrl: {
                    value: true,
                    errorMessage: 'Please enter a valid URL. (For eg, www.twitter.com/username)'
                },
            },
            valid: true,
            touched: false
        }
    },
    LEgetStartedMessageForm: {
        message: {
            elementType: 'textarea',
            elementConfig: {
                type: 'text'
            },
            value: '',
            label: 'Message',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
            },
            valid: false,
            totalChar: 500,
            remainingChar: 500,
            touched: false
        }
    },
    signInForm: {
        username: {
            elementType: 'input',
            elementConfig: {
                type: 'text'
            },
            value: '',
            label: 'Username or Email',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
            },
            valid: false,
            touched: false
        },
        password: {
            elementType: 'input',
            elementConfig: {
                type: 'password'
            },
            value: '',
            label: 'Password',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
            },
            valid: false,
            touched: false
        }
    },
    signUpForm: {
        username: {
            elementType: 'textarea',
            elementConfig: {
                type: 'text'
            },
            value: '',
            label: 'Username',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
                isUsername: {
                    value: true,
                    errorMessage: 'Invalid username. Allowed characters are letters, digits, _ , ., - and @'
                },
                maxLength: {
                    value: true,
                    limit: 100,
                    errorMessage: 'Username is too large'
                }
            },
            valid: false,
            touched: false,
            totalChar: 24,
            remainingChar: 24,
            errorMessage: ''
        },
        email: {
            elementType: 'input',
            elementConfig: {
                type: 'email',
            },
            value: '',
            label: 'Email ID',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
                isEmail: {
                    value: true,
                    errorMessage: 'Please enter a valid email',
                },
            },
            valid: false,
            touched: false,
            errorMessage: ''
        },
        // firstname: {
        //     elementType: 'input',
        //     elementConfig: {
        //         type: 'text'
        //     },
        //     value: '',
        //     label: 'First Name',
        //     disabled: false,
        //     validation: {
        //         required: {
        //             value: true,
        //             errorMessage: 'This is a required field'
        //         },
        //         isName: {
        //             value: true,
        //             errorMessage: 'Please enter a valid name'
        //         }
        //     },
        //     valid: false,
        //     touched: false,
        //     errorMessage: ''
        // },
        // lastname: {
        //     elementType: 'input',
        //     elementConfig: {
        //         type: 'text'
        //     },
        //     value: '',
        //     label: 'Last Name',
        //     disabled: false,
        //     validation: {
        //         required: {
        //             value: false,
        //             errorMessage: ''
        //         },
        //         isName: {
        //             value: true,
        //             errorMessage: 'Please enter a valid name'
        //         }
        //     },
        //     valid: false,
        //     touched: false
        // },
        password: {
            elementType: 'input',
            elementConfig: {
                type: 'password'
            },
            value: '',
            label: 'Password',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
                isPassword: {
                    value: true,
                    errorMessage: 'Please enter a valid password',
                    tooltip: 'Password should be 8-16 characters long. Allowed characters are letters, digits, _, #, $ and @.'
                },
            },
            valid: false,
            touched: false,
            errorMessage: '',
            tooltipText: ''
        },
        // confirmPassword: {
        //     elementType: 'input',
        //     elementConfig: {
        //         type: 'password'
        //     },
        //     value: '',
        //     label: 'Confirm Password',
        //     disabled: false,
        //     validation: {
        //         required: {
        //             value: true,
        //             errorMessage: 'This is a required field'
        //         },
        //         isPassword: {
        //             value: true,
        //             errorMessage: 'Please enter a valid password',
        //             tooltip: 'Password should be 8-16 characters long. Allowed characters are letters, digits, _, # and @.'
        //         },
        //         matchPassword: {
        //             value: true,
        //             errorMessage: 'Password and Confirm Password do not match'
        //         }
        //     },
        //     valid: false,
        //     touched: false,
        //     errorMessage: '',
        //     tooltipText: ''
        // }
    },
    forgotPasswordModalForm: {
        email: {
            elementType: 'input',
            elementConfig: {
                type: 'email',
            },
            value: '',
            label: 'Email ID',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
                isEmail: {
                    value: true,
                    errorMessage: 'Please enter a valid email',
                },
            },
            valid: false,
            touched: false
        }
    },
    resendVerificationMailModalForm: {
        email: {
            elementType: 'input',
            elementConfig: {
                type: 'email',
            },
            value: '',
            label: 'Email ID',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
                isEmail: {
                    value: true,
                    errorMessage: 'Please enter a valid email',
                },
            },
            valid: false,
            touched: false
        }
    },
    editProfileForm: {
        username: {
            elementType: 'input',
            elementConfig: {
                type: 'text',
                placeholder: 'Username'
            },
            value: '',
            label: 'Username',
            disabled: true,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
                isUsername: {
                    value: true,
                    errorMessage: 'Invalid username. Allowed characters are letter, digits, _ , ., - and @'
                }
            },
            valid: true,
            touched: false,
            errorMessage: ''
        },
        channelName: {
            elementType: 'textarea',
            elementConfig: {
                type: 'text',
            },
            value: '',
            label: 'Channel Name',
            disabled: false,
            validation: {
                required: {
                    value: false,
                    errorMessage: 'This is a required field'
                },
            },
            valid: false,
            touched: false,
            totalChar: 24,
            remainingChar: 24,
            errorMessage: ''
        },
        email: {
            elementType: 'input',
            elementConfig: {
                type: 'email',
            },
            value: '',
            label: 'Email ID',
            disabled: true,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
                isEmail: {
                    value: true,
                    errorMessage: 'Please enter a valid email.'
                }
            },
            valid: false,
            touched: false,
            errorMessage: ''
        },
        phone: {
            elementType: 'input',
            elementConfig: {
                type: 'text',
            },
            value: '',
            label: 'Phone Number (For eg, +919739xxxxx9 for India)',
            disabled: false,
            validation: {
                required: {
                    value: false,
                    errorMessage: 'This is a required field'
                },
                isPhone: {
                    value: true,
                    errorMessage: 'Please enter a valid phone number'
                }
            },
            valid: false,
            touched: false,
            errorMessage: ''
        },
        firstname: {
            elementType: 'input',
            elementConfig: {
                type: 'text'
            },
            value: '',
            label: 'First Name',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
                isName: {
                    value: true,
                    errorMessage: 'Please enter a valid name'
                }
            },
            valid: false,
            touched: false,
            errorMessage: ''
        },
        lastname: {
            elementType: 'input',
            elementConfig: {
                type: 'text'
            },
            value: '',
            label: 'Last Name',
            disabled: false,
            validation: {
                required: {
                    value: false,
                    errorMessage: 'This is a required field'
                },
                isName: {
                    value: true,
                    errorMessage: 'Please enter a valid name'
                }
            },
            valid: false,
            touched: false,
            errorMessage: ''
        },
        twitter: {
            elementType: 'input',
            elementConfig: {
                type: 'text'
            },
            value: '',
            label: 'Twitter',
            disabled: false,
            validation: {
                required: {
                    value: false,
                    errorMessage: 'This is a required field'
                },
                isUrl: {
                    value: true,
                    errorMessage: 'Please enter a valid URL. (For eg, https://www.twitter.com/username)'
                },
            },
            valid: false,
            touched: false,
            errorMessage: ''
        },
        linkedIn: {
            elementType: 'input',
            elementConfig: {
                type: 'text'
            },
            value: '',
            label: 'LinkedIn',
            disabled: false,
            validation: {
                required: {
                    value: false,
                    errorMessage: 'This is a required field'
                },
                isUrl: {
                    value: true,
                    errorMessage: 'Please enter a valid URL. (For eg, https://www.linkedin.com/in/username)'
                },
            },
            valid: true,
            touched: false,
            errorMessage: ''
        },
        github: {
            elementType: 'input',
            elementConfig: {
                type: 'text',
            },
            value: '',
            label: 'Github',
            disabled: false,
            validation: {
                required: {
                    value: false,
                    errorMessage: 'This is a required field'
                },
                isUrl: {
                    value: true,
                    errorMessage: 'Please enter a valid URL. (For eg, https://www.github.com/username)'
                },
            },
            valid: false,
            touched: false,
            errorMessage: ''
        },
        website: {
            elementType: 'input',
            elementConfig: {
                type: 'text',
            },
            value: '',
            label: 'Website',
            disabled: false,
            validation: {
                required: {
                    value: false,
                    errorMessage: 'This is a required field'
                },
                isUrl: {
                    value: true,
                    errorMessage: 'Please enter a valid URL. (For eg, https://www.edyoda.com)'
                },
            },
            valid: false,
            touched: false,
            errorMessage: ''
        },
        tagline: {
            elementType: 'textarea',
            elementConfig: {
                type: 'text',
            },
            value: '',
            label: 'Tagline',
            disabled: false,
            validation: {
                required: {
                    value: false,
                    errorMessage: 'This is a required field'
                },
            },
            valid: false,
            touched: false,
            totalChar: 80,
            remainingChar: 80,
            errorMessage: ''
        },
        bio: {
            elementType: 'textarea',
            elementConfig: {
                type: 'text'
            },
            value: '',
            label: 'Bio',
            disabled: false,
            validation: {
                required: {
                    value: false,
                    errorMessage: 'This is a required field'
                },
            },
            valid: false,
            touched: false,
            totalChar: 500,
            remainingChar: 500,
            errorMessage: ''
        },
        expertise: {
            elementType: 'input',
            elementConfig: {
                type: 'text'
            },
            value: '',
            label: 'Expertise (For eg, Machine Learning, Android Development, Django)',
            disabled: false,
            validation: {
                required: {
                    value: false,
                    errorMessage: 'This is a required field'
                },
            },
            valid: false,
            touched: false,
            errorMessage: ''
        },
    },
    changePasswordForm: {
        oldPassword: {
            elementType: 'input',
            elementConfig: {
                type: 'password'
            },
            value: '',
            label: 'Old Password',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
                isPassword: {
                    value: true,
                    errorMessage: 'Please enter a valid password',
                    tooltip: 'Password should be 8-16 characters long. Allowed characters are letters, digits, _, #, $ and @.'
                },
            },
            valid: false,
            touched: false,
            errorMessage: '',
            tooltipText: '',
        },
        newPassword: {
            elementType: 'input',
            elementConfig: {
                type: 'password'
            },
            value: '',
            label: 'New Password',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
                isPassword: {
                    value: true,
                    errorMessage: 'Please enter a valid password',
                    tooltip: 'Password should be 8-16 characters long. Allowed characters are letters, digits, _, #, $ and @.'
                },
            },
            valid: false,
            touched: false,
            errorMessage: '',
            tooltipText: '',
        },
        newPasswordCopy: {
            elementType: 'input',
            elementConfig: {
                type: 'password'
            },
            value: '',
            label: 'Confirm Password',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
                isPassword: {
                    value: true,
                    errorMessage: 'Please enter a valid password',
                    tooltip: 'Password should be 8-16 characters long. Allowed characters are letters, digits, _, #, $ and @.'
                },
                matchPassword: {
                    value: true,
                    errorMessage: 'Password and Confirm Password do not match'
                }
            },
            valid: false,
            touched: false,
            errorMessage: '',
            tooltipText: ''
        }
    },
    resetPasswordForm: {
        password: {
            elementType: 'input',
            elementConfig: {
                type: 'password'
            },
            value: '',
            label: 'New Password',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
                isPassword: {
                    value: true,
                    errorMessage: 'Please enter a valid password',
                    tooltip: 'Password should be 8-16 characters long. Allowed characters are letters, digits, _, #, $ and @.'
                },
            },
            valid: false,
            touched: false
        },
        confirmPassword: {
            elementType: 'input',
            elementConfig: {
                type: 'password'
            },
            value: '',
            label: 'Re-enter Password',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
                isPassword: {
                    value: true,
                    errorMessage: 'Please enter a valid password',
                    tooltip: 'Password should be 8-16 characters long. Allowed characters are letters, digits, _, #, $ and @.'
                },
                matchPassword: {
                    value: true,
                    errorMessage: 'Password and Confirm Password do not match'
                }
            },
            valid: false,
            touched: false
        }
    },
    contactUsForm: {
        name: {
            elementType: 'input',
            elementConfig: {
                type: 'text'
            },
            value: '',
            label: 'Name',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
                isName: {
                    value: true,
                    errorMessage: 'Please enter a valid name'
                }
            },
            valid: false,
            touched: false,
            errorMessage: ''
        },
        email: {
            elementType: 'input',
            elementConfig: {
                type: 'email',
            },
            value: '',
            label: 'Email ID',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
                isEmail: {
                    value: true,
                    errorMessage: 'Please enter a valid email.'
                }
            },
            valid: false,
            touched: false,
            errorMessage: ''
        },
        phone: {
            elementType: 'input',
            elementConfig: {
                type: 'text',
            },
            value: '',
            label: 'Phone Number (For eg, +919739xxxxx9 for India)',
            disabled: false,
            validation: {
                required: {
                    value: false,
                    errorMessage: 'This is a required field'
                },
                isPhone: {
                    value: true,
                    errorMessage: 'Please enter a valid phone number'
                }
            },
            valid: false,
            touched: false,
            errorMessage: ''
        },
        message: {
            elementType: 'textarea',
            elementConfig: {
                type: 'text',
            },
            value: '',
            label: 'Message',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
            },
            valid: false,
            totalChar: 500,
            remainingChar: 500,
            touched: false,
            errorMessage: ''
        },
    },
    creatorQueryForm: {
        name: {
            elementType: 'input',
            elementConfig: {
                type: 'text'
            },
            value: '',
            label: 'Name',
            disabled: false,
            validation: {
                required: {
                    value: false,
                    errorMessage: 'This is a required field'
                },
                isName: {
                    value: true,
                    errorMessage: 'Please enter a valid name'
                }
            },
            valid: false,
            touched: false,
            errorMessage: ''
        },
        email: {
            elementType: 'input',
            elementConfig: {
                type: 'email',
            },
            value: '',
            label: 'Email ID',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
                isEmail: {
                    value: true,
                    errorMessage: 'Please enter a valid email.'
                }
            },
            valid: false,
            touched: false,
            errorMessage: ''
        },
        phone: {
            elementType: 'input',
            elementConfig: {
                type: 'text',
            },
            value: '',
            label: 'Phone Number (For eg, +919739xxxxx9 for India)',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
                isPhone: {
                    value: true,
                    errorMessage: 'Please enter a valid phone number'
                }
            },
            valid: false,
            touched: false,
            errorMessage: ''
        },
        message: {
            elementType: 'textarea',
            elementConfig: {
                type: 'text',
            },
            value: '',
            label: 'Message',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
            },
            valid: false,
            totalChar: 500,
            remainingChar: 500,
            touched: false,
            errorMessage: ''
        },
    },
    feedbackForm: {
        email: {
            elementType: 'input',
            elementConfig: {
                type: 'email',
            },
            value: '',
            label: 'Email ID',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
                isEmail: {
                    value: true,
                    errorMessage: 'Please enter a valid email.'
                }
            },
            valid: false,
            touched: false,
            errorMessage: ''
        },
        phone: {
            elementType: 'input',
            elementConfig: {
                type: 'text',
            },
            value: '',
            label: 'Phone Number (e.g. +919739xxxxx9 for India)',
            disabled: false,
            validation: {
                required: {
                    value: false,
                    errorMessage: 'This is a required field'
                },
                isPhone: {
                    value: true,
                    errorMessage: 'Please enter a valid phone number'
                }
            },
            valid: false,
            touched: false,
            errorMessage: ''
        },
        message: {
            elementType: 'textarea',
            elementConfig: {
                type: 'text',
            },
            value: '',
            label: 'Message',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
            },
            valid: false,
            totalChar: 500,
            remainingChar: 500,
            touched: false,
            errorMessage: ''
        },
    },
    buildProfileBasicInfoForm: {
        fullName: {
            elementType: 'input',
            elementConfig: {
                type: 'text'
            },
            value: '',
            label: 'Full Name',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
                isName: {
                    value: true,
                    errorMessage: 'Please enter a valid name'
                }
            },
            valid: false,
            touched: false,
            errorMessage: ''
        },
        email: {
            elementType: 'input',
            elementConfig: {
                type: 'email',
            },
            value: '',
            label: 'Email ID',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
                isEmail: {
                    value: true,
                    errorMessage: 'Please enter a valid email',
                },
            },
            valid: false,
            touched: false,
            errorMessage: ''
        },
        phone: {
            elementType: 'input',
            elementConfig: {
                type: 'text',
            },
            value: '',
            label: 'Phone Number (For eg, +919739xxxxx9 for India)',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
                isPhone: {
                    value: true,
                    errorMessage: 'Please enter a valid phone number'
                }
            },
            valid: false,
            touched: false,
            errorMessage: ''
        },
        whatsappPhone: {
            elementType: 'input',
            elementConfig: {
                type: 'text',
            },
            value: '',
            label: 'Whatsapp Number (For eg, +919739xxxxx9 for India)',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
                isPhone: {
                    value: true,
                    errorMessage: 'Please enter a valid phone number'
                }
            },
            valid: false,
            touched: false,
            errorMessage: ''
        },
        linkedIn: {
            elementType: 'input',
            elementConfig: {
                type: 'text'
            },
            value: '',
            label: 'LinkedIn',
            disabled: false,
            validation: {
                required: {
                    value: false,
                    errorMessage: 'This is a required field'
                },
                isUrl: {
                    value: true,
                    errorMessage: 'Please enter a valid URL. (For eg, https://www.linkedin.com/in/username)'
                },
            },
            valid: true,
            touched: false,
            errorMessage: ''
        },
        github: {
            elementType: 'input',
            elementConfig: {
                type: 'text',
            },
            value: '',
            label: 'Github',
            disabled: false,
            validation: {
                required: {
                    value: false,
                    errorMessage: 'This is a required field'
                },
                isUrl: {
                    value: true,
                    errorMessage: 'Please enter a valid URL. (For eg, https://www.github.com/username)'
                },
            },
            valid: true,
            touched: false,
            errorMessage: ''
        },
        twitter: {
            elementType: 'input',
            elementConfig: {
                type: 'text'
            },
            value: '',
            label: 'Twitter',
            disabled: false,
            validation: {
                required: {
                    value: false,
                    errorMessage: 'This is a required field'
                },
                isUrl: {
                    value: true,
                    errorMessage: 'Please enter a valid URL. (For eg, https://www.twitter.com/username)'
                },
            },
            valid: true,
            touched: false,
            errorMessage: ''
        },
        website: {
            elementType: 'input',
            elementConfig: {
                type: 'text'
            },
            value: '',
            label: 'Website',
            disabled: false,
            validation: {
                required: {
                    value: false,
                    errorMessage: 'This is a required field'
                },
                isUrl: {
                    value: true,
                    errorMessage: 'Please enter a valid URL. (For eg, https://www.edyoda.com)'
                },
            },
            valid: true,
            touched: false
        },
        hackerrank: {
            elementType: 'input',
            elementConfig: {
                type: 'text'
            },
            value: '',
            label: 'Hackerrank',
            disabled: false,
            validation: {
                required: {
                    value: false,
                    errorMessage: 'This is a required field'
                },
                isUrl: {
                    value: true,
                    errorMessage: 'Please enter a valid URL.'
                },
            },
            valid: true,
            touched: false
        },
        codepen: {
            elementType: 'input',
            elementConfig: {
                type: 'text'
            },
            value: '',
            label: 'Codepen',
            disabled: false,
            validation: {
                required: {
                    value: false,
                    errorMessage: 'This is a required field'
                },
                isUrl: {
                    value: true,
                    errorMessage: 'Please enter a valid URL.'
                },
            },
            valid: true,
            touched: false
        }
    },
    buildProfileTopSkillForm: {
        skills: {
            elementType: 'input',
            elementConfig: {
                type: 'text'
            },
            value: '',
            label: 'Add a New Skill (For eg, HTML, JAVA, Python)',
            disabled: false,
            validation: {
                required: {
                    value: false,
                    errorMessage: 'This is a required field'
                },
            },
            valid: false,
            touched: false,
            errorMessage: ''
        }
    },
    buildProfileWorkExperienceForm: {
        companyName: {
            elementType: 'textarea',
            elementConfig: {
                type: 'text'
            },
            value: '',
            label: 'Company Name',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                }
            },
            valid: false,
            touched: false,
            totalChar: 150,
            remainingChar: 150,
            errorMessage: ''
        },
        role: {
            elementType: 'textarea',
            elementConfig: {
                type: 'text',
            },
            value: '',
            label: 'Your Role',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
            },
            valid: false,
            touched: false,
            totalChar: 150,
            remainingChar: 150,
            errorMessage: ''
        },
        responsibilities: {
            elementType: 'textarea',
            elementConfig: {
                type: 'text',
            },
            value: '',
            label: 'Major Responsibilities',
            disabled: false,
            validation: {
                required: {
                    value: false,
                    errorMessage: 'This is a required field'
                }
            },
            valid: false,
            touched: false,
            totalChar: 500,
            remainingChar: 500,
            errorMessage: ''
        },
        startDate: {
            elementType: 'input',
            elementConfig: {
                type: 'date',
            },
            value: '',
            label: 'Start Date',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
                startDate: {
                    value: true,
                    errorMessage: 'Start date cannot be greater than current date'
                }
            },
            valid: false,
            touched: true,
            errorMessage: ''
        },
        endDate: {
            elementType: 'input',
            elementConfig: {
                type: 'date',
            },
            value: '',
            label: 'End Date',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
                endDate: {
                    value: true,
                    errorMessage: 'End date cannot be less than start date'
                }
            },
            valid: false,
            touched: true,
            errorMessage: ''
        },
        projectUrl: {
            elementType: 'input',
            elementConfig: {
                type: 'text',
            },
            value: '',
            label: 'Project URL',
            disabled: false,
            validation: {
                required: {
                    value: false,
                    errorMessage: 'This is a required field'
                },
                isUrl: {
                    value: true,
                    errorMessage: 'Please enter a valid URL. (For eg, https://www.edyoda.com)'
                },
            },
            valid: false,
            touched: false,
            errorMessage: ''
        }
    },
    buildProfileMyInfoForm: {
        title: {
            elementType: 'textarea',
            elementConfig: {
                type: 'text'
            },
            value: '',
            label: 'Title (For e.g. Data Scientist, React Developer)',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                }
            },
            valid: false,
            touched: false,
            totalChar: 30,
            remainingChar: 30,
            errorMessage: ''
        },
        tagline: {
            elementType: 'textarea',
            elementConfig: {
                type: 'text'
            },
            value: '',
            label: 'Tagline',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                }
            },
            valid: false,
            touched: false,
            totalChar: 200,
            remainingChar: 200,
            errorMessage: ''
        },
        about: {
            elementType: 'textarea',
            elementConfig: {
                type: 'text',
            },
            value: '',
            label: 'About',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                }
            },
            valid: false,
            touched: false,
            totalChar: 500,
            remainingChar: 500,
            errorMessage: ''
        },
        languages: {
            elementType: 'textarea',
            elementConfig: {
                type: 'text'
            },
            value: '',
            label: 'Languages (For e.g. English, Hindi, etc)',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                }
            },
            valid: false,
            touched: false,
            errorMessage: ''
        },
    },
    buildProfileEducationForm: {
        degreeName: {
            elementType: 'textarea',
            elementConfig: {
                type: 'text'
            },
            value: '',
            label: 'Degree Name (For eg, High School or B.Tech. in CS)',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                }
            },
            valid: false,
            touched: false,
            totalChar: 150,
            remainingChar: 150,
            errorMessage: ''
        },
        instituteName: {
            elementType: 'textarea',
            elementConfig: {
                type: 'text',
            },
            value: '',
            label: 'Institute Name',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                }
            },
            valid: false,
            touched: false,
            totalChar: 150,
            remainingChar: 150,
            errorMessage: ''
        },
        score: {
            elementType: 'input',
            elementConfig: {
                type: 'text'
            },
            value: '0',
            label: 'Score (For eg, 85 if percentage or 8.5 if CGPA)',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
                isNumber: {
                    value: true,
                    errorMessage: 'Please enter a valid value'
                }
            },
            valid: false,
            touched: false,
            errorMessage: ''
        },
        scoreType: {
            elementType: 'select',
            elementConfig: {
                type: 'text',
            },
            options: [
                {
                    id: 1,
                    label: '%',
                    value: '%'
                },
                {
                    id: 2,
                    label: 'CGPA',
                    value: 'CGPA'
                }
            ],
            dropdownOpen: false,
            value: 0,
            label: 'Score Type',
            disabled: false,
            validation: {
                required: {
                    value: false,
                    errorMessage: 'This is a required field'
                },
                isDropdown: {
                    value: true,
                    errorMessage: 'Please select a value from dropdown'
                }
            },
            valid: true,
            touched: true,
            errorMessage: ''
        },
        yearOfCompletion: {
            elementType: 'input',
            elementConfig: {
                type: 'text',
            },
            value: '',
            label: 'Year of Completion',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
                isYear: {
                    value: true,
                    errorMessage: 'Please enter a valid year'
                }
            },
            valid: false,
            touched: false,
            errorMessage: ''
        }
    },
    buildProfileHonorsAccomplishmentsForm: {
        description: {
            elementType: 'textarea',
            elementConfig: {
                type: 'text'
            },
            value: '',
            label: 'Description',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                }
            },
            valid: false,
            touched: false,
            totalChar: 150,
            remainingChar: 150,
            errorMessage: ''
        },
        link: {
            elementType: 'input',
            elementConfig: {
                type: 'text'
            },
            value: '',
            label: 'Link',
            disabled: false,
            validation: {
                required: {
                    value: false,
                    errorMessage: 'This is a required field'
                }
            },
            valid: false,
            touched: false,
            errorMessage: ''
        },
    },
    programEnrollForm: {
        name: {
            elementType: 'input',
            elementConfig: {
                type: 'text'
            },
            value: '',
            label: 'Name',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
                isName: {
                    value: true,
                    errorMessage: 'Please enter a valid name'
                }
            },
            valid: false,
            touched: false,
            errorMessage: ''
        },
        email: {
            elementType: 'input',
            elementConfig: {
                type: 'email',

            },
            value: '',
            label: 'Email ID',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
                isEmail: {
                    value: true,
                    errorMessage: 'Please enter a valid email.'
                }
            },
            valid: false,
            touched: false,
            errorMessage: ''
        },
        phone: {
            elementType: 'input',
            elementConfig: {
                type: 'text',

            },
            value: '',
            label: 'Phone Number (For eg, +919739xxxxx9 for India)',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
                isPhone: {
                    value: true,
                    errorMessage: 'Please enter a valid phone number'
                }
            },
            valid: false,
            touched: false,
            errorMessage: ''
        }
    },
    requestUserInfoForm: {
        name: {
            elementType: 'input',
            elementConfig: {
                type: 'text'
            },
            value: '',
            label: 'Name',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
                isName: {
                    value: true,
                    errorMessage: 'Please enter a valid name'
                }
            },
            valid: false,
            touched: false,
            errorMessage: ''
        },
        email: {
            elementType: 'input',
            elementConfig: {
                type: 'email',
            },
            value: '',
            label: 'Email ID',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
                isEmail: {
                    value: true,
                    errorMessage: 'Please enter a valid email.'
                }
            },
            valid: false,
            touched: false,
            errorMessage: ''
        },
        phone: {
            elementType: 'input',
            elementConfig: {
                type: 'text',
            },
            value: '',
            label: 'Phone Number (For eg, +919739xxxxx9 for India)',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
                isPhone: {
                    value: true,
                    errorMessage: 'Please enter a valid phone number'
                }
            },
            valid: false,
            touched: false,
            errorMessage: ''
        },
    },
    updateUserInfoForm: {
        name: {
            elementType: 'input',
            elementConfig: {
                type: 'text'
            },
            value: '',
            label: 'Name',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
                isName: {
                    value: true,
                    errorMessage: 'Please enter a valid name'
                }
            },
            valid: false,
            touched: false,
            errorMessage: ''
        },
        email: {
            elementType: 'input',
            elementConfig: {
                type: 'email',
            },
            value: '',
            label: 'Email ID',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
                isEmail: {
                    value: true,
                    errorMessage: 'Please enter a valid email.'
                }
            },
            valid: false,
            touched: false,
            errorMessage: ''
        },
        phone: {
            elementType: 'input',
            elementConfig: {
                type: 'text',
            },
            value: '',
            label: 'Phone Number (For eg, +919739xxxxx9 for India)',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
                isPhone: {
                    value: true,
                    errorMessage: 'Please enter a valid phone number'
                }
            },
            valid: false,
            touched: false,
            errorMessage: ''
        },
        verificationCode: {
            elementType: 'input',
            elementConfig: {
                type: 'text',
            },
            value: '',
            label: 'Verification Code',
            disabled: false,
            validation: {
                required: {
                    value: false,
                    errorMessage: 'Verification code can not be empty'
                }
            },
            valid: false,
            touched: false,
            errorMessage: ''
        },
    },
    newQuizProblemFormData: {
        difficultyLevel: {
            elementType: 'select',
            elementConfig: {
                type: 'text',
            },
            options: [
                {
                    id: 1,
                    label: 'Easy',
                    value: 'easy'
                },
                {
                    id: 2,
                    label: 'Medium',
                    value: 'medium'
                },
                {
                    id: 3,
                    label: 'Hard',
                    value: 'hard'
                },
            ],
            dropdownOpen: false,
            value: -1,
            label: 'Difficulty Level',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
                isDropdown: {
                    value: true,
                    errorMessage: 'Please select a value from dropdown'
                },
            },
            valid: false,
            touched: false,
            errorMessage: ''
        },
        maxScore: {
            elementType: 'input',
            elementConfig: {
                type: 'text'
            },
            value: '',
            label: 'Max Score',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
            },
            valid: false,
            touched: false,
            errorMessage: ''
        },
        numberOfCorrectAnswers: {
            elementType: 'select',
            elementConfig: {
                type: 'text',
            },
            options: [
                {
                    id: 1,
                    label: 'Single',
                    value: 'single'
                },
                {
                    id: 2,
                    label: 'Multiple',
                    value: 'multiple'
                }
            ],
            dropdownOpen: false,
            value: 0,
            label: 'Number of Correct Answers',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
                isDropdown: {
                    value: true,
                    errorMessage: 'Please select a value from dropdown'
                },
            },
            valid: false,
            touched: false,
            errorMessage: ''
        },
        questionDescription: {
            elementType: 'markdown',
            elementConfig: {
                type: 'text'
            },
            value: '',
            label: 'Question Description',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
            },
            valid: false,
            touched: false,
            totalChar: 1000,
            remainingChar: 1000,
            errorMessage: ''
        },
    },
    createNewQuizForm: {
        quizTitle: {
            elementType: 'textarea',
            elementConfig: {
                type: 'text'
            },
            value: '',
            label: 'Title',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                }
            },
            valid: false,
            touched: false,
            totalChar: 150,
            remainingChar: 150,
            errorMessage: ''
        },
        startDate: {
            elementType: 'input',
            elementConfig: {
                type: 'date',
                min: new Date().toLocaleDateString(),
                max: new Date(Date.now() + 15 * 24 * 60 * 60 * 1000).toLocaleDateString()
            },
            value: '',
            label: 'Start Date',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
                date: {
                    value: true,
                    errorMessage: 'Please enter a valid date (mm/dd/yyyy).'
                }
            },
            valid: false,
            touched: true,
            errorMessage: ''
        },
        startTime: {
            elementType: 'input',
            elementConfig: {
                type: 'time',
            },
            value: '',
            label: 'Start Time',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
                startTime: {
                    value: true,
                    errorMessage: 'Please enter a valid time.'
                }
            },
            valid: true,
            touched: true
        },
        dueDate: {
            elementType: 'input',
            elementConfig: {
                type: 'date',
                min: new Date().toLocaleDateString(),
                max: new Date(Date.now() + 15 * 24 * 60 * 60 * 1000).toLocaleDateString()
            },
            value: '',
            label: 'Due Date',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
                date: {
                    value: true,
                    errorMessage: 'Please enter a valid date (mm/dd/yyyy).'
                }
            },
            valid: true,
            touched: true,
            errorMessage: ''
        },
        dueTime: {
            elementType: 'input',
            elementConfig: {
                type: 'time',
            },
            value: '',
            label: 'Due Time',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
                dueTime: {
                    value: true,
                    errorMessage: 'Please enter a valid time.'
                }
            },
            valid: true,
            touched: true
        },
        passMark: {
            elementType: 'input',
            elementConfig: {
                type: 'text'
            },
            value: '75',
            label: '',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
                isNumber: {
                    value: true,
                    errorMessage: 'Please enter a valid percentage'
                },
                isPercentage: {
                    value: true,
                    errorMessage: 'Value should be less than 100'
                }
            },
            valid: false,
            touched: false,
            errorMessage: ''
        },
        timeLimit: {
            elementType: 'input',
            elementConfig: {
                type: 'text'
            },
            value: '30',
            label: '',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
                isNumber: {
                    value: true,
                    errorMessage: 'Please enter a valid time'
                }
            },
            valid: false,
            touched: false,
            errorMessage: ''
        },
    },
    sendWANotificationFormData: {
        templatesDropdown: {
            elementType: 'select',
            elementConfig: {
                type: 'text',
            },
            options: [
                { id: 0, label: 'None', value: 'None' },
            ],
            dropdownOpen: false,
            value: 0,
            label: 'Select Template',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
                isDropdown: {
                    value: true,
                    errorMessage: ''
                },
            },
            valid: false,
            touched: false,
            errorMessage: ''
        }
    },
    sendNotificationFormData: {
        tagInput: {
            elementType: 'select',
            elementConfig: {
                type: 'text',
            },
            options: [
                { id: 0, label: 'Live Session', value: 'Live Session' },
                { id: 1, label: 'Certification Update', value: 'Certification Update' },
                { id: 2, label: 'Community Update', value: 'Community Update' },
                { id: 3, label: 'Program Fee', value: 'Program Fee' },
                { id: 4, label: 'Upcoming EMI', value: 'Upcoming EMI' },
                { id: 5, label: 'Payment Due', value: 'Payment Due' },
                { id: 5, label: 'Fee Application Pending', value: 'Fee Application Pending' },
                { id: 6, label: 'Assignment Reminder', value: 'Assignment Reminder' },
                { id: 7, label: 'Quiz Reminder', value: 'Quiz Reminder' },
                { id: 8, label: 'PRM Update', value: 'PRM Update' },
                { id: 9, label: 'Interview Update', value: 'Interview Update' },
                { id: 10, label: 'Job Post Update', value: 'Job Post Update' },
            ],
            dropdownOpen: false,
            value: 0,
            label: 'Notification Category',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
                isDropdown: {
                    value: true,
                    errorMessage: ''
                },
            },
            valid: false,
            touched: false,
            errorMessage: ''
        },
        titleInput: {
            elementType: 'textarea',
            elementConfig: {
                type: 'text'
            },
            value: '',
            label: 'Title',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                }
            },
            valid: false,
            touched: false,
            totalChar: 150,
            remainingChar: 150,
            errorMessage: 'Please enter a title.'
        },
        batchCodeInput: {
            elementType: 'textarea',
            elementConfig: {
                type: 'text'
            },
            value: '',
            label: 'Batch Code',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                }
            },
            valid: false,
            touched: false,
            errorMessage: 'Please enter a valid batch code.'
        },
        cta: {
            elementType: 'textarea',
            elementConfig: {
                type: 'text'
            },
            value: '',
            label: 'CTA (Button Name)',
            disabled: false,
            validation: {
                required: {
                    value: false,
                    errorMessage: 'This is a required field'
                }
            },
            valid: false,
            touched: false,
            errorMessage: ''
        },
        email: {
            elementType: 'input',
            elementConfig: {
                type: 'email',
            },
            value: '',
            label: 'Email ID',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This field is required'
                },
                isEmail: {
                    value: true,
                    errorMessage: 'Please enter a valid email id'
                }
            },
            valid: false,
            touched: false,
            errorMessage: ''
        },
        url: {
            elementType: 'textarea',
            elementConfig: {
                type: 'text'
            },
            value: '',
            label: 'Paste the URL here',
            disabled: false,
            validation: {
                required: {
                    value: false,
                    errorMessage: 'This is a required field'
                }
            },
            valid: false,
            touched: false,
            totalChar: 150,
            remainingChar: 150,
            errorMessage: ''
        },
        notificationType: {
            elementType: 'select',
            elementConfig: {
                type: 'text',
            },
            options: [
                {
                    id: 1,
                    label: 'Announcement',
                    value: 'announcement'
                },
                {
                    id: 2,
                    label: 'Notification',
                    value: 'notification'
                },
                {
                    id: 3,
                    label: 'Toast',
                    value: 'toast'
                },
                {
                    id: 4,
                    label: 'Popup',
                    value: 'popup'
                },
            ],
            dropdownOpen: false,
            value: 0,
            label: 'Notification Type',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
                isDropdown: {
                    value: true,
                    errorMessage: ''
                },
            },
            valid: false,
            touched: false,
            errorMessage: ''
        },
        mdCourses: {
            elementType: 'select',
            elementConfig: {
                type: 'text',
            },
            options: [...mdCoursesForNotificationDropdown],
            dropdownOpen: false,
            value: 0,
            label: 'Select MD Course',
            disabled: false,
            validation: {
                required: {
                    value: false,
                    errorMessage: 'This is a required field'
                },
                isDropdown: {
                    value: true,
                    errorMessage: ''
                },
            },
            valid: true,
            touched: true,
            errorMessage: ''
        },
        messageInput: {
            elementType: 'markdown',
            elementConfig: {
                type: 'text'
            },
            value: '',
            label: 'Message ',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
            },
            valid: false,
            touched: false,
            totalChar: 1000,
            remainingChar: 1000,
            errorMessage: 'Please enter the message.'
        },
        expireDate: {
            elementType: 'input',
            elementConfig: {
                type: 'date',
                min: new Date().toLocaleDateString(),
                max: new Date(Date.now() + 15 * 24 * 60 * 60 * 1000).toLocaleDateString()
            },
            value: '',
            label: 'Expire Date',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
                date: {
                    value: true,
                    errorMessage: 'Please enter a valid date (mm/dd/yyyy).'
                }
            },
            valid: false,
            touched: true,
            errorMessage: ''
        },
        expireTime: {
            elementType: 'input',
            elementConfig: {
                type: 'time',
            },
            value: '',
            label: 'Expire Time',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
                expireTime: {
                    value: true,
                    errorMessage: 'Please enter a valid time.'
                }
            },
            valid: true,
            touched: true
        },
    },
    sendBulkNotificationFormData: {
        titleInput: {
            elementType: 'textarea',
            elementConfig: {
                type: 'text'
            },
            value: '',
            label: 'Title',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                }
            },
            valid: false,
            touched: false,
            totalChar: 150,
            remainingChar: 150,
            errorMessage: ''
        },
        email: {
            elementType: 'input',
            elementConfig: {
                type: 'email',
            },
            value: '',
            label: 'Email ID',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
                isEmail: {
                    value: true,
                    errorMessage: 'Please enter a valid email.'
                }
            },
            valid: false,
            touched: false,
            errorMessage: ''
        },
        url: {
            elementType: 'textarea',
            elementConfig: {
                type: 'text'
            },
            value: '',
            label: 'Paste the URL here',
            disabled: false,
            validation: {
                required: {
                    value: false,
                    errorMessage: 'This is a required field'
                }
            },
            valid: false,
            touched: false,
            totalChar: 150,
            remainingChar: 150,
            errorMessage: ''
        },
        notificationType: {
            elementType: 'select',
            elementConfig: {
                type: 'text',
            },
            options: [
                {
                    id: 1,
                    label: 'Announcement',
                    value: 'announcement'
                },
                {
                    id: 2,
                    label: 'Notification',
                    value: 'notification'
                },
                {
                    id: 3,
                    label: 'Action Required',
                    value: 'action_required'
                },
                {
                    id: 4,
                    label: 'Popup',
                    value: 'popup'
                },
            ],
            dropdownOpen: false,
            value: 0,
            label: 'Notification Type',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
                isDropdown: {
                    value: true,
                    errorMessage: 'Please select a value from dropdown'
                },
            },
            valid: false,
            touched: false,
            errorMessage: ''
        },
        messageInput: {
            elementType: 'markdown',
            elementConfig: {
                type: 'text'
            },
            value: '',
            label: 'Message ',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
            },
            valid: false,
            touched: false,
            totalChar: 5000,
            remainingChar: 5000,
            errorMessage: ''
        },
    },

    newAssignmentProblemFormData: {
        assignmentTitle: {
            elementType: 'textarea',
            elementConfig: {
                type: 'text'
            },
            value: '',
            label: 'Title',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                }
            },
            valid: false,
            touched: false,
            totalChar: 150,
            remainingChar: 150,
            errorMessage: ''
        },
        difficultyLevel: {
            elementType: 'select',
            elementConfig: {
                type: 'text',
            },
            options: [
                {
                    id: 1,
                    label: 'Easy',
                    value: 'easy'
                },
                {
                    id: 2,
                    label: 'Medium',
                    value: 'medium'
                },
                {
                    id: 3,
                    label: 'Hard',
                    value: 'hard'
                },
            ],
            dropdownOpen: false,
            value: 0,
            label: 'Difficulty Level',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
                isDropdown: {
                    value: true,
                    errorMessage: 'Please select a value from dropdown'
                },
            },
            valid: false,
            touched: false,
            errorMessage: ''
        },
        // maxScore: {
        //     elementType: 'input',
        //     elementConfig: {
        //         type: 'text'
        //     },
        //     value: ' ',
        //     label: 'Max Score',
        //     disabled: false,
        //     validation: {
        //         required: {
        //             value: true,
        //             errorMessage: 'This is a required field'
        //         },
        //     },
        //     valid: false,
        //     touched: false,
        //     errorMessage: ''
        // },
        problemDescription: {
            elementType: 'markdown',
            elementConfig: {
                type: 'text'
            },
            value: '',
            label: 'Problem Description',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
            },
            valid: false,
            touched: false,
            totalChar: 5000,
            remainingChar: 5000,
            errorMessage: ''
        },
    },
    createNewAssignmentForm: {
        assignmentTitle: {
            elementType: 'textarea',
            elementConfig: {
                type: 'text'
            },
            value: '',
            label: 'Title',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                }
            },
            valid: false,
            touched: false,
            totalChar: 150,
            remainingChar: 150,
            errorMessage: ''
        },
        startDate: {
            elementType: 'input',
            elementConfig: {
                type: 'date',
                min: new Date().toLocaleDateString(),
                max: new Date(Date.now() + 15 * 24 * 60 * 60 * 1000).toLocaleDateString()
            },
            value: '',
            label: 'Start Date',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
                date: {
                    value: true,
                    errorMessage: 'Please enter a valid date (mm/dd/yyyy).'
                }
            },
            valid: false,
            touched: true,
            errorMessage: ''
        },
        startTime: {
            elementType: 'input',
            elementConfig: {
                type: 'time',
            },
            value: '',
            label: 'Start Time',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
                startTime: {
                    value: true,
                    errorMessage: 'Please enter a valid time.'
                }
            },
            valid: true,
            touched: true
        },
        dueDate: {
            elementType: 'input',
            elementConfig: {
                type: 'date',
                min: new Date().toLocaleDateString(),
                max: new Date(Date.now() + 15 * 24 * 60 * 60 * 1000).toLocaleDateString()
            },
            value: '',
            label: 'Due Date',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
                date: {
                    value: true,
                    errorMessage: 'Please enter a valid date (mm/dd/yyyy).'
                }
            },
            valid: true,
            touched: true,
            errorMessage: ''
        },
        dueTime: {
            elementType: 'input',
            elementConfig: {
                type: 'time',
            },
            value: '',
            label: 'Due Time',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
                dueTime: {
                    value: true,
                    errorMessage: 'Please enter a valid time.'
                }
            },
            valid: true,
            touched: true
        },
        passMark: {
            elementType: 'input',
            elementConfig: {
                type: 'text'
            },
            value: '75',
            label: '',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
                isNumber: {
                    value: true,
                    errorMessage: 'Please enter a valid percentage'
                },
                isPercentage: {
                    value: true,
                    errorMessage: 'Value should be less than 100'
                }
            },
            valid: false,
            touched: false,
            errorMessage: ''
        }
    },
    createNewTopicForm: {
        topicTitle: {
            elementType: 'textarea',
            elementConfig: {
                type: 'text'
            },
            value: '',
            label: 'Title',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                }
            },
            valid: false,
            touched: false,
            totalChar: 150,
            remainingChar: 150,
            errorMessage: ''
        },
        startDate: {
            elementType: 'input',
            elementConfig: {
                type: 'date',
                min: new Date().toLocaleDateString(),
                max: new Date(Date.now() + 15 * 24 * 60 * 60 * 1000).toLocaleDateString()
            },
            value: '',
            label: 'Start Date',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
                date: {
                    value: true,
                    errorMessage: 'Please enter a valid date (mm/dd/yyyy).'
                }
            },
            valid: false,
            touched: true,
            errorMessage: ''
        },
        startTime: {
            elementType: 'input',
            elementConfig: {
                type: 'time',
            },
            value: '',
            label: 'Start Time',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
                startTime: {
                    value: true,
                    errorMessage: 'Please enter a valid time.'
                }
            },
            valid: true,
            touched: true
        }
    },

    rescheduleContentForm: {
        currentDate: {
            elementType: 'input',
            elementConfig: {
                type: 'date',
                min: new Date().toLocaleDateString(),
                max: new Date(Date.now() + 15 * 24 * 60 * 60 * 1000).toLocaleDateString()
            },
            value: '',
            label: 'Current Date',
            disabled: true,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
                date: {
                    value: true,
                    errorMessage: 'Please enter a valid date (mm/dd/yyyy).'
                }
            },
            valid: false,
            touched: true,
            errorMessage: ''
        },
        rescheduledDate: {
            elementType: 'input',
            elementConfig: {
                type: 'date',
                min: new Date().toLocaleDateString(),
                max: new Date(Date.now() + 15 * 24 * 60 * 60 * 1000).toLocaleDateString()
            },
            value: '',
            label: 'Rescheduled Date',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
                date: {
                    value: true,
                    errorMessage: 'Please enter a valid date (mm/dd/yyyy).'
                }
            },
            valid: false,
            touched: true,
            errorMessage: ''
        },
    },
    newProblemFormData: {
        assignmentTitle: {
            elementType: 'textarea',
            elementConfig: {
                type: 'text'
            },
            value: '',
            label: 'Title',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                }
            },
            valid: false,
            touched: false,
            totalChar: 150,
            remainingChar: 150,
            errorMessage: ''
        },
        difficultyLevel: {
            elementType: 'select',
            elementConfig: {
                type: 'text',
            },
            options: [
                {
                    id: 1,
                    label: 'Easy',
                    value: 'easy'
                },
                {
                    id: 2,
                    label: 'Medium',
                    value: 'medium'
                },
                {
                    id: 3,
                    label: 'Hard',
                    value: 'hard'
                },
            ],
            dropdownOpen: false,
            value: 0,
            label: 'Difficulty Level',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
                isDropdown: {
                    value: true,
                    errorMessage: 'Please select a value from dropdown'
                },
            },
            valid: false,
            touched: false,
            errorMessage: ''
        },
        maxScore: {
            elementType: 'input',
            elementConfig: {
                type: 'text'
            },
            value: ' ',
            label: 'Max Score',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
            },
            valid: false,
            touched: false,
            errorMessage: ''
        },
        problemDescription: {
            elementType: 'markdown',
            elementConfig: {
                type: 'text'
            },
            value: '',
            label: 'Problem Description',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
            },
            valid: false,
            touched: false,
            totalChar: 1000,
            remainingChar: 1000,
            errorMessage: ''
        },
    },
    liveSessionFormData: {
        startDate: {
            elementType: 'input',
            elementConfig: {
                type: 'date',
                min: new Date().toLocaleDateString(),
                max: new Date(Date.now() + 15 * 24 * 60 * 60 * 1000).toLocaleDateString()
            },
            value: '',
            label: 'Start Date',
            disabled: false,
            valid: true,
            touched: true
        },
        startTime: {
            elementType: 'input',
            elementConfig: {
                type: 'time',
            },
            value: '',
            label: 'Start Time',
            disabled: false,
            valid: true,
            touched: true
        },
        endDate: {
            elementType: 'input',
            elementConfig: {
                type: 'date',
                min: new Date().toLocaleDateString(),
                max: new Date(Date.now() + 15 * 24 * 60 * 60 * 1000).toLocaleDateString()
            },
            value: '',
            label: 'End Date',
            disabled: false,
            valid: true,
            touched: true
        },
        endTime: {
            elementType: 'input',
            elementConfig: {
                type: 'time',
            },
            value: '',
            label: 'End Time',
            disabled: false,
            valid: true,
            touched: true
        },
        startURL: {
            elementType: 'textarea',
            elementConfig: {
                type: 'text'
            },
            value: '',
            label: 'Start URL',
            disabled: false,
            valid: true,
            touched: true
        },
        signature: {
            elementType: 'textarea',
            elementConfig: {
                type: 'text'
            },
            value: '',
            label: 'Signature',
            disabled: false,
            valid: true,
            touched: true
        },
        meetId: {
            elementType: 'textarea',
            elementConfig: {
                type: 'text'
            },
            value: '',
            label: 'Meet ID',
            disabled: false,
            valid: true,
            touched: true
        },
        password: {
            elementType: 'textarea',
            elementConfig: {
                type: 'text'
            },
            value: '',
            label: 'Password',
            disabled: false,
            valid: true,
            touched: true
        },
        encPassword: {
            elementType: 'textarea',
            elementConfig: {
                type: 'text'
            },
            value: '',
            label: 'Encrypted Password',
            disabled: false,
            valid: true,
            touched: true
        },

    },


    sessionPlanFormData: {
        sessionDescription: {
            elementType: 'markdown',
            elementConfig: {
                type: 'text'
            },
            value: '',
            label: '',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
            },
            valid: false,
            touched: false,
            // totalChar: 7000,
            // remainingChar: 7000,
            errorMessage: ''
        },
    },
    editTopicForm: {
        topicName: {
            elementType: 'input',
            elementConfig: {
                type: 'text'
            },
            value: '',
            label: 'Topic Name',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
            },
            valid: false,
            touched: false,
            errorMessage: ''
        },
        scheduleDate: {
            elementType: 'input',
            elementConfig: {
                type: 'date'
            },
            value: '',
            label: 'Date',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
                date: {
                    value: true,
                    errorMessage: 'Please enter a valid date (mm/dd/yyyy).'
                }
            },
            valid: false,
            touched: true,
            errorMessage: ''
        },
        scheduleTime: {
            elementType: 'input',
            elementConfig: {
                type: 'time',
            },
            value: '',
            label: 'Time',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
                startTime: {
                    value: true,
                    errorMessage: 'Please enter a valid time.'
                }
            },
            valid: false,
            touched: true
        },
    },
    CertificationTabForm: {
        scheduleDate: {
            elementType: 'input',
            elementConfig: {
                type: 'date'
            },
            value: '',
            label: 'Date',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
                date: {
                    value: true,
                    errorMessage: 'Please enter a valid date (mm/dd/yyyy).'
                }
            },
            valid: false,
            touched: true,
            errorMessage: ''
        },
        scheduleTime: {
            elementType: 'input',
            elementConfig: {
                type: 'time',
            },
            value: '',
            label: 'Time',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
                startTime: {
                    value: true,
                    errorMessage: 'Please enter a valid time.'
                }
            },
            valid: false,
            touched: true
        },
    },
    accountSettingsForm: {
        fullName: {
            elementType: 'input',
            elementConfig: {
                type: 'text'
            },
            value: '',
            label: 'Full Name',
            disabled: false,
            validation: {
                required: {
                    value: false,
                    errorMessage: 'This is a required field'
                },
                isName: {
                    value: true,
                    errorMessage: 'Please enter a valid name'
                }
            },
            valid: false,
            touched: false,
            errorMessage: ''
        },
        email: {
            elementType: 'input',
            elementConfig: {
                type: 'email',
            },
            value: '',
            label: 'Email ID',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
                isEmail: {
                    value: true,
                    errorMessage: 'Please enter a valid email',
                },
            },
            valid: false,
            touched: false,
            errorMessage: ''
        },
        username: {
            elementType: 'input',
            elementConfig: {
                type: 'text',
                placeholder: ''
            },
            value: '',
            label: 'Username',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
                isUsername: {
                    value: true,
                    errorMessage: 'Invalid username. Allowed characters are letter, digits, _ , ., - and @'
                }
            },
            valid: true,
            touched: false,
            errorMessage: ''
        },
        phone: {
            elementType: 'input',
            elementConfig: {
                type: 'text',
            },
            value: '',
            label: 'Phone Number (For eg, +919739xxxxx9 for India)',
            disabled: false,
            validation: {
                required: {
                    value: false,
                    errorMessage: 'This is a required field'
                },
                isPhone: {
                    value: true,
                    errorMessage: 'Please enter a valid phone number'
                }
            },
            valid: false,
            touched: false,
            errorMessage: ''
        },
        rcrm_slug: {
            elementType: 'input',
            elementConfig: {
                type: 'text',
            },
            value: '',
            label: 'Rcrm Slug',
            validation: {
                required: {
                    value: false,
                    errorMessage: 'This is a required field'
                },
            },
            valid: false,
            touched: false,
            errorMessage: ''
        }
    },
    addNewLearnerForm: {
        fullName: {
            elementType: 'input',
            elementConfig: {
                type: 'text'
            },
            value: '',
            label: 'Full Name',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
                isName: {
                    value: true,
                    errorMessage: 'Please enter a valid name'
                }
            },
            valid: false,
            touched: false,
            errorMessage: ''
        },
        email: {
            elementType: 'input',
            elementConfig: {
                type: 'email',
            },
            value: '',
            label: 'Email ID',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
                isEmail: {
                    value: true,
                    errorMessage: 'Please enter a valid email',
                },
            },
            valid: false,
            touched: false,
            errorMessage: ''
        },
        username: {
            elementType: 'input',
            elementConfig: {
                type: 'text',
                placeholder: ''
            },
            value: '',
            label: 'Username',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
                isUsername: {
                    value: true,
                    errorMessage: 'Invalid username. Allowed characters are letter, digits, _ , ., - and @'
                }
            },
            valid: true,
            touched: false,
            errorMessage: ''
        },
        phone: {
            elementType: 'input',
            elementConfig: {
                type: 'text',
            },
            value: '',
            label: 'Phone (For eg, +919739xxxxx9 for India)',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
                isPhone: {
                    value: true,
                    errorMessage: 'Please enter a valid phone number'
                }
            },
            valid: false,
            touched: false,
            errorMessage: ''
        },
        paymentAmount: {
            elementType: 'input',
            elementConfig: {
                type: 'text',
                placeholder: ''
            },
            value: '',
            label: 'Payment Amount',
            disabled: false,
            validation: {
                required: {
                    value: false,
                    errorMessage: 'This is a required field'
                }
            },
            valid: true,
            touched: false,
            errorMessage: ''
        },
        utmParams: {
            elementType: 'input',
            elementConfig: {
                type: 'text',
                placeholder: ''
            },
            value: '',
            label: 'UTM Params',
            disabled: false,
            validation: {
                required: {
                    value: false,
                    errorMessage: 'This is a required field'
                }
            },
            valid: true,
            touched: false,
            errorMessage: ''
        },
    },
    addNewInstructorForm: {
        fullName: {
            elementType: 'input',
            elementConfig: {
                type: 'text'
            },
            value: '',
            label: 'Full Name',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
                isName: {
                    value: true,
                    errorMessage: 'Please enter a valid name'
                }
            },
            valid: false,
            touched: false,
            errorMessage: ''
        },
        email: {
            elementType: 'input',
            elementConfig: {
                type: 'email',
            },
            value: '',
            label: 'Email ID',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
                isEmail: {
                    value: true,
                    errorMessage: 'Please enter a valid email',
                },
            },
            valid: false,
            touched: false,
            errorMessage: ''
        },
        username: {
            elementType: 'input',
            elementConfig: {
                type: 'text',
                placeholder: ''
            },
            value: '',
            label: 'Username',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
                isUsername: {
                    value: true,
                    errorMessage: 'Invalid username. Allowed characters are letter, digits, _ , ., - and @'
                }
            },
            valid: true,
            touched: false,
            errorMessage: ''
        },
        phone: {
            elementType: 'input',
            elementConfig: {
                type: 'text',
            },
            value: '',
            label: 'Phone Number (For eg, +919739xxxxx9 for India)',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
                isPhone: {
                    value: true,
                    errorMessage: 'Please enter a valid phone number'
                }
            },
            valid: false,
            touched: false,
            errorMessage: ''
        }
    },
    editProgramTabForm: {
        programName: {
            elementType: 'textarea',
            elementConfig: {
                type: 'text'
            },
            value: '',
            label: 'Program Name',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                }
            },
            valid: false,
            touched: false,
            totalChar: 150,
            remainingChar: 150,
            errorMessage: ''
        },
        startDate: {
            elementType: 'input',
            elementConfig: {
                type: 'date'
            },
            value: '',
            label: 'Start Date',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
                date: {
                    value: true,
                    errorMessage: 'Please enter a valid date (mm/dd/yyyy).'
                }
            },
            valid: false,
            touched: true,
            errorMessage: ''
        },
        endDate: {
            elementType: 'input',
            elementConfig: {
                type: 'date'
            },
            value: '',
            label: 'End Date',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
                date: {
                    value: true,
                    errorMessage: 'Please enter a valid date (mm/dd/yyyy).'
                }
            },
            valid: true,
            touched: true,
            errorMessage: ''
        }
    },
    createNewProgramForm: {
        programTitle: {
            elementType: 'input',
            elementConfig: {
                type: 'text'
            },
            value: '',
            label: 'Title',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                }
            },
            valid: false,
            touched: false,
            totalChar: 150,
            remainingChar: 150,
            errorMessage: ''
        },
        batchCode: {
            elementType: 'input',
            elementConfig: {
                type: 'text'
            },
            value: '',
            label: 'Batch Code',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                }
            },
            valid: false,
            touched: false,
            totalChar: 150,
            remainingChar: 150,
            errorMessage: ''
        },
        startDate: {
            elementType: 'input',
            elementConfig: {
                type: 'date'
            },
            value: '',
            label: 'Start Date',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
                date: {
                    value: true,
                    errorMessage: 'Please enter a valid date (mm/dd/yyyy).'
                }
            },
            valid: false,
            touched: true,
            errorMessage: ''
        },
        endDate: {
            elementType: 'input',
            elementConfig: {
                type: 'date'
            },
            value: '',
            label: 'End Date',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
                date: {
                    value: true,
                    errorMessage: 'Please enter a valid date (mm/dd/yyyy).'
                }
            },
            valid: false,
            touched: true,
            errorMessage: ''
        },
        startTime: {
            elementType: 'input',
            elementConfig: {
                type: 'time',
            },
            value: '19:30',
            label: 'Start Time',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
                startTime: {
                    value: true,
                    errorMessage: 'Please enter a valid time.'
                }
            },
            valid: true,
            touched: true
        },
        certificationsCount: {
            elementType: 'input',
            elementConfig: {
                type: 'text'
            },
            value: '0',
            label: 'Certifications Count',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                }
            },
            valid: true,
            touched: true,
            totalChar: 2,
            remainingChar: 2,
            errorMessage: ''
        },
    },
    EmailReportData: {
        fromDate: {
            elementType: 'input',
            elementConfig: {
                type: 'date',
                min: new Date().toLocaleDateString(),
                max: new Date(Date.now() + 15 * 24 * 60 * 60 * 1000).toLocaleDateString()
            },
            value: '',
            label: 'From Date',
            disabled: false,
            valid: true,
            touched: true
        },
        fromTime: {
            elementType: 'input',
            elementConfig: {
                type: 'time',
            },
            value: '',
            label: 'From Time',
            disabled: false,
            valid: true,
            touched: true
        },
        toDate: {
            elementType: 'input',
            elementConfig: {
                type: 'date',
                min: new Date().toLocaleDateString(),
                max: new Date(Date.now() + 15 * 24 * 60 * 60 * 1000).toLocaleDateString()
            },
            value: '',
            label: 'To Date',
            disabled: false,
            valid: true,
            touched: true
        },
        toTime: {
            elementType: 'input',
            elementConfig: {
                type: 'time',
            },
            value: '',
            label: 'To Time',
            disabled: false,
            valid: true,
            touched: true
        },
    },
    createNewModuleForm: {
        moduleTitle: {
            elementType: 'input',
            elementConfig: {
                type: 'text'
            },
            value: '',
            label: 'Title',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                }
            },
            valid: false,
            touched: false,
            totalChar: 150,
            remainingChar: 150,
            errorMessage: ''
        },
        startDate: {
            elementType: 'input',
            elementConfig: {
                type: 'date'
            },
            value: '',
            label: 'Start Date',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
                date: {
                    value: true,
                    errorMessage: 'Please enter a valid date (mm/dd/yyyy).'
                }
            },
            valid: false,
            touched: true,
            errorMessage: ''
        },
        endDate: {
            elementType: 'input',
            elementConfig: {
                type: 'date'
            },
            value: '',
            label: 'End Date',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
                date: {
                    value: true,
                    errorMessage: 'Please enter a valid date (mm/dd/yyyy).'
                }
            },
            valid: false,
            touched: true,
            errorMessage: ''
        },
        startTime: {
            elementType: 'input',
            elementConfig: {
                type: 'time',
            },
            value: '19:30',
            label: 'Start Time',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
                startTime: {
                    value: true,
                    errorMessage: 'Please enter a valid time.'
                }
            },
            valid: true,
            touched: true
        },
    },
    editLiveModuleForm: {
        moduleTitle: {
            elementType: 'input',
            elementConfig: {
                type: 'text'
            },
            value: '',
            label: 'Module Code',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                }
            },
            valid: false,
            touched: false,
            totalChar: 150,
            remainingChar: 150,
            errorMessage: ''
        },
        startDate: {
            elementType: 'input',
            elementConfig: {
                type: 'date'
            },
            value: '',
            label: 'Start Date',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
                date: {
                    value: true,
                    errorMessage: 'Please enter a valid date (mm/dd/yyyy).'
                }
            },
            valid: false,
            touched: true,
            errorMessage: ''
        },
        endDate: {
            elementType: 'input',
            elementConfig: {
                type: 'date'
            },
            value: '',
            label: 'End Date',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
                date: {
                    value: true,
                    errorMessage: 'Please enter a valid date (mm/dd/yyyy).'
                }
            },
            valid: false,
            touched: true,
            errorMessage: ''
        },
        startTime: {
            elementType: 'input',
            elementConfig: {
                type: 'time',
            },
            value: '19:30',
            label: 'Start Time',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
                startTime: {
                    value: true,
                    errorMessage: 'Please enter a valid time.'
                }
            },
            valid: true,
            touched: true
        },
        courseTitle: {
            elementType: 'input',
            elementConfig: {
                type: 'text'
            },
            value: '',
            label: 'Course Title',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                }
            },
            valid: false,
            touched: false,
            totalChar: 150,
            remainingChar: 150,
            errorMessage: ''
        },
        whatWillYouLearn: {
            elementType: 'textarea',
            elementConfig: {
                type: 'text'
            },
            value: '',
            label: 'What will you learn',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                }
            },
            valid: false,
            touched: false,
            totalChar: 350,
            remainingChar: 350,
            errorMessage: ''
        },
        courseDescription: {
            elementType: 'textarea',
            elementConfig: {
                type: 'text'
            },
            value: '',
            label: 'Course Description',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                }
            },
            valid: false,
            touched: false,
            totalChar: 350,
            remainingChar: 350,
            errorMessage: ''
        },
        skillsYouWillLearn: {
            elementType: 'textarea',
            elementConfig: {
                type: 'text'
            },
            value: '',
            label: "Skills You'll Learn (Separate by semicolon ';')",
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                }
            },
            valid: false,
            touched: false,
            totalChar: 350,
            remainingChar: 350,
            errorMessage: ''
        },
        courseCategory: {
            elementType: 'textarea',
            elementConfig: {
                type: 'text'
            },
            value: '',
            label: "Category",
            disabled: false,
            validation: {
                required: {
                    value: false,
                    errorMessage: 'This is a required field'
                }
            },
            valid: false,
            touched: false,
            totalChar: 350,
            remainingChar: 350,
            errorMessage: ''
        },
        courseRating: {
            elementType: 'input',
            elementConfig: {
                type: 'text'
            },
            value: '',
            label: 'Course Rating',
            disabled: false,
            validation: {
                required: {
                    value: false,
                    errorMessage: 'This is a required field'
                }
            },
            valid: false,
            touched: false,
            totalChar: 150,
            remainingChar: 150,
            errorMessage: ''
        },
        instructorRating: {
            elementType: 'input',
            elementConfig: {
                type: 'text'
            },
            value: '',
            label: 'Instructor Rating',
            disabled: false,
            validation: {
                required: {
                    value: false,
                    errorMessage: 'This is a required field'
                }
            },
            valid: false,
            touched: false,
            totalChar: 150,
            remainingChar: 150,
            errorMessage: ''
        },
    },
    saveReportFormData: {
        reportTitle: {
            elementType: 'input',
            elementConfig: {
                type: 'text'
            },
            value: '',
            label: 'Report Title',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
                isTitle: {
                    value: true,
                    errorMessage: 'Please enter a valid title.'
                }
            },
            valid: false,
            touched: false,
            errorMessage: ''
        },
        reportDescription: {
            elementType: 'markdown',
            elementConfig: {
                type: 'text'
            },
            value: '',
            label: 'Description',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
                isDescription: {
                    value: true,
                    errorMessage: 'Please write description'
                },
            },
            valid: false,
            touched: false,
            totalChar: 150,
            remainingChar: 150,
            errorMessage: ''
        },
    },
    uploadResources: {
        fileTitle: {
            elementType: 'input',
            elementConfig: {
                type: 'text'
            },
            value: '',
            label: 'File Name',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                }
            },
            valid: false,
            touched: true,
            totalChar: 150,
            remainingChar: 150,
            errorMessage: ''
        },
        vimeoID: {
            elementType: 'input',
            elementConfig: {
                type: 'text'
            },
            value: '',
            label: 'Vimeo ID',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                }
            },
            valid: false,
            touched: true,
            totalChar: 150,
            remainingChar: 150,
            errorMessage: ''
        },
    },
    uploadResourcesTPStreams: {
        fileTitle: {
            elementType: 'input',
            elementConfig: {
                type: 'text'
            },
            value: '',
            label: 'File Name',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                }
            },
            valid: false,
            touched: true,
            totalChar: 150,
            remainingChar: 150,
            errorMessage: ''
        },
        assetId: {
            elementType: 'input',
            elementConfig: {
                type: 'text'
            },
            value: '',
            label: 'Asset Id',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                }
            },
            valid: false,
            touched: true,
            totalChar: 150,
            remainingChar: 150,
            errorMessage: ''
        },
        accessToken: {
            elementType: 'input',
            elementConfig: {
                type: 'text'
            },
            value: '',
            label: 'Access Token',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                }
            },
            valid: false,
            touched: true,
            totalChar: 150,
            remainingChar: 150,
            errorMessage: ''
        },
    },
    cloneQuizForm: {
        quizTitle: {
            elementType: 'textarea',
            elementConfig: {
                type: 'text'
            },
            value: '',
            label: 'Title',
            disabled: true,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                }
            },
            valid: true,
            touched: true,
            totalChar: 150,
            remainingChar: 150,
            errorMessage: ''
        },
        startDate: {
            elementType: 'input',
            elementConfig: {
                type: 'date',
                min: new Date().toLocaleDateString(),
                max: new Date(Date.now() + 15 * 24 * 60 * 60 * 1000).toLocaleDateString()
            },
            value: '',
            label: 'Start Date',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
                date: {
                    value: true,
                    errorMessage: 'Please enter a valid date (mm/dd/yyyy).'
                }
            },
            valid: false,
            touched: true,
            errorMessage: ''
        },
        startTime: {
            elementType: 'input',
            elementConfig: {
                type: 'time',
            },
            value: '',
            label: 'Start Time',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
                startTime: {
                    value: true,
                    errorMessage: 'Please enter a valid time.'
                }
            },
            valid: true,
            touched: true
        },
        dueDate: {
            elementType: 'input',
            elementConfig: {
                type: 'date',
                min: new Date().toLocaleDateString(),
                max: new Date(Date.now() + 15 * 24 * 60 * 60 * 1000).toLocaleDateString()
            },
            value: '',
            label: 'Due Date',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
                date: {
                    value: true,
                    errorMessage: 'Please enter a valid date (mm/dd/yyyy).'
                }
            },
            valid: true,
            touched: true,
            errorMessage: ''
        },
        dueTime: {
            elementType: 'input',
            elementConfig: {
                type: 'time',
            },
            value: '',
            label: 'Due Time',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
                dueTime: {
                    value: true,
                    errorMessage: 'Please enter a valid time.'
                }
            },
            valid: true,
            touched: true
        }
    },
    cloneAssignmentForm: {
        assignmentTitle: {
            elementType: 'textarea',
            elementConfig: {
                type: 'text'
            },
            value: '',
            label: 'Title',
            disabled: true,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                }
            },
            valid: true,
            touched: true,
            totalChar: 150,
            remainingChar: 150,
            errorMessage: ''
        },
        startDate: {
            elementType: 'input',
            elementConfig: {
                type: 'date',
                min: new Date().toLocaleDateString(),
                max: new Date(Date.now() + 15 * 24 * 60 * 60 * 1000).toLocaleDateString()
            },
            value: '',
            label: 'Start Date',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
                date: {
                    value: true,
                    errorMessage: 'Please enter a valid date (mm/dd/yyyy).'
                }
            },
            valid: false,
            touched: true,
            errorMessage: ''
        },
        startTime: {
            elementType: 'input',
            elementConfig: {
                type: 'time',
            },
            value: '',
            label: 'Start Time',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
                startTime: {
                    value: true,
                    errorMessage: 'Please enter a valid time.'
                }
            },
            valid: true,
            touched: true
        },
        dueDate: {
            elementType: 'input',
            elementConfig: {
                type: 'date',
                min: new Date().toLocaleDateString(),
                max: new Date(Date.now() + 15 * 24 * 60 * 60 * 1000).toLocaleDateString()
            },
            value: '',
            label: 'Due Date',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
                date: {
                    value: true,
                    errorMessage: 'Please enter a valid date (mm/dd/yyyy).'
                }
            },
            valid: true,
            touched: true,
            errorMessage: ''
        },
        dueTime: {
            elementType: 'input',
            elementConfig: {
                type: 'time',
            },
            value: '',
            label: 'Due Time',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
                dueTime: {
                    value: true,
                    errorMessage: 'Please enter a valid time.'
                }
            },
            valid: true,
            touched: true
        }
    },
    ReattemptForm: {
        name: {
            elementType: 'input',
            elementConfig: {
                type: 'text'
            },
            value: '',
            label: 'Full Name',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
                isName: {
                    value: true,
                    errorMessage: 'Please enter a valid name'
                }
            },
            valid: false,
            touched: false,
            errorMessage: ''
        },
        email: {
            elementType: 'input',
            elementConfig: {
                type: 'email',
            },
            value: '',
            label: 'Email',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
                isEmail: {
                    value: true,
                    errorMessage: 'Please enter a valid email.'
                }
            },
            valid: false,
            touched: false,
            errorMessage: ''
        },
        phone: {
            elementType: 'input',
            elementConfig: {
                type: 'text',
            },
            value: '',
            label: 'Contact Number (For eg, +919739xxxxx9 for India)',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
                isPhone: {
                    value: true,
                    errorMessage: 'Please enter a valid phone number'
                }
            },
            valid: false,
            touched: false,
            errorMessage: ''
        },
    },
    submitProjectLinksForm: {
        codeFileURL: {
            elementType: 'input',
            elementConfig: {
                type: 'text'
            },
            value: '',
            label: 'Code File URL',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
                isName: {
                    value: true,
                    errorMessage: 'Please enter a valid name'
                }
            },
            valid: false,
            touched: false,
            errorMessage: ''
        },
        publicVideoURL: {
            elementType: 'input',
            elementConfig: {
                type: 'text'
            },
            value: '',
            label: 'Public Video URL',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
                isName: {
                    value: true,
                    errorMessage: 'Please enter a valid name'
                }
            },
            valid: false,
            touched: false,
            errorMessage: ''
        },
        hostedWebAppURL: {
            elementType: 'input',
            elementConfig: {
                type: 'text'
            },
            value: '',
            label: 'Hosted Web App URL',
            disabled: false,
            validation: {
                required: {
                    value: true,
                    errorMessage: 'This is a required field'
                },
                isName: {
                    value: true,
                    errorMessage: 'Please enter a valid name'
                }
            },
            valid: false,
            touched: false,
            errorMessage: ''
        },
    }
}


export default fields;